import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ParentsFeedbackListComponent } from './parents-feedback-list/parents-feedback-list.component';
import { ParentsFeedbackViewComponent } from './parents-feedback-view/parents-feedback-view.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: ParentsFeedbackListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      /* {
        path: 'view-page',
        component: ParentsFeedbackViewComponent,
        data: {
          title: "View Page",
          breadcrumb: "View Page"
        }
      }, */
      {
        path: 'parents-feedback-view/:id',
        component: ParentsFeedbackViewComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ParentsFeedbackRoutingModule { }
